import { GENERATION_TOOL } from 'src/data/generationTool';
import { PROJECT_TYPE } from 'src/data/project';

import { TEMPLATE_TAG } from './tags';
import type { GenericTemplate } from './types';

const GENERIC_TEMPLATES: GenericTemplate[] = [
  // Blog
  {
    projectType: PROJECT_TYPE.blogPostBuilder,
    generationTool: GENERATION_TOOL.blogDescription,
    tags: [
      TEMPLATE_TAG.channelBlog,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.articleBlogHeadline,
    tags: [
      TEMPLATE_TAG.channelBlog,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },

  // Ads
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.facebookMixtureAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleAppAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleDemandGenAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleDisplayAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googlePerformanceMaxAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleRSA,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleShoppingAd,
    tags: [TEMPLATE_TAG.channelAds, TEMPLATE_TAG.b2cEcommerceWebsiteOptimization],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleVideoAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinMixtureAd,
    tags: [TEMPLATE_TAG.channelAds, TEMPLATE_TAG.b2bBrandCommunications],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinConversationAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bFieldMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinLeadGenFormAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2bFieldMarketing,
      TEMPLATE_TAG.b2bDemandGeneration,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinDocumentAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2bFieldMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinTextAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2bFieldMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinMessageAd,
    tags: [TEMPLATE_TAG.channelAds, TEMPLATE_TAG.b2bDemandGeneration, TEMPLATE_TAG.b2bAbm],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinVideoAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bFieldMarketing,
      TEMPLATE_TAG.b2bDemandGeneration,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.outbrainAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.pinterestMixtureAd,
    tags: [TEMPLATE_TAG.channelAds, TEMPLATE_TAG.b2cPrCommunications],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.taboolaAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.twitterMixtureAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  // TODO: Acquisition Ad Campaign	Ads	Ads	Live	DD multi-prompt template

  // Website
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingPageProductAnnouncementMultiPrompt,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingHeadline,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingSubheader,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingCTA,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingBenefits,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingFeatures,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingSEOMetadata,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  // TODO: Case Study - B2B	Website	Website	Live	DD multi-prompt template
  // TODO: Landing Page - SaaS (Lead Generation)	Website	Website	Live	DD multi-prompt template

  // Social
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.instagramCaption,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.facebookPost,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.tweet,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinPost,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.pinterestMixturePost,
    tags: [TEMPLATE_TAG.channelSocial, TEMPLATE_TAG.b2cPrCommunications],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.youtubeMixturePost,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPrCommunications,
    ],
  },
  // TODO: Repurpose Blog Content	Social	Social	Live	DD multi-prompt template

  // Email
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.emailDripMultiPrompt,
    tags: [
      TEMPLATE_TAG.channelEmail,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.emailMixture,
    tags: [
      TEMPLATE_TAG.channelEmail,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.emailSubject,
    tags: [
      TEMPLATE_TAG.channelEmail,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
    ],
  },
  // TODO: Newsletter	Email	Email	Live	DD multi-prompt template

  // Ecommerce
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.amazonProductListing,
    tags: [
      TEMPLATE_TAG.channelEcommerce,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.walmartProductListing,
    tags: [
      TEMPLATE_TAG.channelEcommerce,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.generalProductListing,
    tags: [
      TEMPLATE_TAG.channelEcommerce,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.basicProductReview,
    tags: [
      TEMPLATE_TAG.channelEcommerce,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.smsPromotional,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },

  // General writing
  // TODO: AIDA	General Writing	-	Live	DD prompt template
  // TODO: PAS	General Writing	-	Live	DD prompt template
  // TODO: Explain it to a 5th Grader	General Writing	-	Live	DD prompt template
  // TODO: Sentence Expander	General Writing	-	Live	DD prompt template
  // TODO: Talking Points to Paragraph	General Writing	-	Live	DD prompt template
  // TODO: Summarizer	General Writing	-	Live	DD prompt template

  // Images
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.imageWithDescription,
    tags: [
      TEMPLATE_TAG.channelImages,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bFieldMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.imageByStyle,
    tags: [
      TEMPLATE_TAG.channelImages,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bFieldMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },

  // Other
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.productLaunchMultiPrompt,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.freestyle,
    tags: [TEMPLATE_TAG.channelOther],
  },
];

export const getGenericTemplates = (): GenericTemplate[] => {
  return GENERIC_TEMPLATES;
};
